import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import TextField from "material-ui/TextField";
import { Grid, Divider } from "material-ui";
import Table from "../../../table";
import styles from "./styles";
import NoData from "../../../nodata";
import { Link } from "react-router-dom";
import STWiremapDiagram from "../stdiagram";
import { validateFormData } from "../../../../common/formtool";
import { ModalHeader, ModalContents, ModalFooter } from "../../../common/modal";

class SelectCable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      isChanged: false,
      formattedData: props.formattedData
    };
    // this.handleClose = this.handleClose.bind(this);
    // this.onCheckBoxChange = this.onCheckBoxChange.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleClose = () => {
    this.props.onClose();
  };
  selectCable = item => {
    this.props.selectCable(item);
  };

  selectedRows = rows => {
    // this.setState({
    //   selected: rows
    // });
  };
  render() {
    const {
      languages,
      modal,
      translate,
      classes,
      wiremapStandard,
      isTestEdit
    } = this.props;
    const { formattedData, errors, isChanged } = this.state;

    //const _selected = { ...selected };
    const columns = [];

    columns.push({
      id: "url",
      accessor: d => d["url"],
      Cell: o => (
        <div style={{ textAlign: "left", paddingLeft: 40 }}>{o.value}</div>
      )
    });
    columns.push({
      id: "id",
      accessor: d => d["id"],
      show: false
    });
    //targetList = targetList.filter(item => item.url != null);
    return (
      <Modal open={modal} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography
                type="headline"
                color="inherit"
                className={classes.modalHeader}
              >
                {translate(
                  "general_sub_test_wiremap_modal_add_cust_cable_head"
                )}
              </Typography>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon> clear </Icon>
              </Button>
            </ModalHeader>
            {formattedData && formattedData.length > 0 ? (
              <div>
                <ModalContents className={classes.rootModal}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      {formattedData.map((item, key) => {
                        //let nos = key + 1;
                        return (
                          <div>
                            <div className={classes.targetHeading}>
                              <Grid item xs={12} sm={4}>
                                <Typography className={classes.modelName}>
                                  {(key + 1).toString() + ". " + item.name}
                                </Typography>

                                <Button
                                  raised
                                  color="primary"
                                  className={classes.submit}
                                  onClick={() => this.selectCable(item)}
                                  type="submit"
                                >
                                  {translate("sub_set_ping_select_target")}
                                </Button>
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={8}
                                className={classes.wiremap}
                              >
                                <STWiremapDiagram
                                  data={item}
                                  translate={translate}
                                  wiremapStandard={wiremapStandard}
                                  isAdd="false"
                                  isEdit="false"
                                />
                              </Grid>
                            </div>
                            <Divider />
                          </div>
                        );
                      })}
                    </Grid>
                  </Grid>
                </ModalContents>
                <ModalFooter></ModalFooter>
              </div>
            ) : (
              <div className={classes.noDataBox}>
                {isTestEdit === true ? (
                  <span>
                    <Typography type="subheading" color="inherit">
                      {translate("sub_test_empty_cable_list_t1_create")}
                    </Typography>
                    <Typography type="subheading" color="inherit">
                      {translate("sub_test_empty_cable_list_t2_create")}
                    </Typography>
                  </span>
                ) : (
                  <span>
                    <Typography type="subheading" color="inherit">
                      {translate("sub_test_empty_cable_list_t1")}
                    </Typography>
                    <Typography type="subheading" color="inherit">
                      {translate("sub_test_empty_cable_list_t2")}
                      <Link to={`/subtestsetting/wiremapcustomcables`}>
                        {translate("sub_test_cable_list_search_t3")}
                      </Link>
                    </Typography>
                  </span>
                )}
              </div>
            )}
          </Paper>
        </div>
      </Modal>
    );
  }

  componentWillReceiveProps(nextProps) {
    //   const { editSaving } = this.state;
    //   const { customer } = nextProps;
    //   if (!editSaving) {
    //     if (customer) {
    //       this.setState({
    //         customer: { ...customer }
    //       });
    //       return;
    //     }
    //   }
    //   this.setState({
    //     customer: {
    //       ...this.state.customer,
    //       logo: customer ? customer.logo : null,
    //       logopath: customer ? customer.logopath : null
    //     }
    //   });
  }
}

export default withStyles(styles)(SelectCable);



// WEBPACK FOOTER //
// ./src/components/subtestsetting/common/selectCable/index.js